import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { getFriends } from "../../functions/user";
import { Search } from "../../svg";
import "./style.css";

export default function FriendsListModal({ onClose, onSelectFriends, selectedFriends = [] }) {
  const [friends, setFriends] = useState([]);
  const [filteredFriends, setFilteredFriends] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(selectedFriends);
  const { user } = useSelector((state) => ({ ...state }));

  const loadFriends = useCallback(async () => {
    try {
      setLoading(true);
      const friendsList = await getFriends(user.token);
      
      if (Array.isArray(friendsList)) {
        setFriends(friendsList);
        setFilteredFriends(friendsList);
      } else {
        console.error("Error loading friends:", friendsList);
        setFriends([]);
        setFilteredFriends([]);
      }
    } catch (error) {
      console.error("Error loading friends:", error);
      setFriends([]);
      setFilteredFriends([]);
    } finally {
      setLoading(false);
    }
  }, [user.token]);

  useEffect(() => {
    loadFriends();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadFriends]);

  useEffect(() => {
    if (searchQuery) {
      const filtered = friends.filter(friend =>
        `${friend.first_name} ${friend.last_name}`
          .toLowerCase()
          .includes(searchQuery.toLowerCase())
      );
      setFilteredFriends(filtered);
    } else {
      setFilteredFriends(friends);
    }
  }, [searchQuery, friends]);

  const handleFriendToggle = (friendId) => {
    setSelected(prev => {
      const isSelected = prev.includes(friendId);
      if (isSelected) {
        return prev.filter(id => id !== friendId);
      } else {
        return [...prev, friendId];
      }
    });
  };

  const handleDone = () => {
    const selectedFriendsData = friends.filter(friend => selected.includes(friend._id));
    onSelectFriends(selectedFriendsData);
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <div className="friends_list_modal">
      <div className="friends_list_modal_content">
        <div className="friends_list_modal_header">
          <h3>Tag Friends</h3>
          <button className="close_btn" onClick={handleCancel}>
            <i className="exit_icon"></i>
          </button>
        </div>
        
        <div className="friends_list_search">
          <div className="search_wrap">
            <Search color="#65676b" />
            <input
              type="text"
              placeholder="Search friends..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>

        <div className="friends_list_content">
          {loading ? (
            <div className="loading_friends">
              <div className="spinner">
                <div className="bounce1"></div>
                <div className="bounce2"></div>
                <div className="bounce3"></div>
              </div>
              <span>Loading friends...</span>
            </div>
          ) : filteredFriends.length > 0 ? (
            <div className="friends_list">
              {filteredFriends.map((friend) => (
                <div 
                  key={friend._id} 
                  className={`friend_item ${selected.includes(friend._id) ? 'selected' : ''}`}
                  onClick={() => handleFriendToggle(friend._id)}
                >
                  <div className="friend_avatar">
                    <img 
                      src={friend.picture} 
                      alt="" 
                      className="friend_picture"
                    />
                    {selected.includes(friend._id) && (
                      <div className="selected_checkmark">
                        <i className="check_icon"></i>
                      </div>
                    )}
                  </div>
                  <div className="friend_info">
                    <span className="friend_name">
                      {friend.name || `${friend.first_name || ""} ${friend.last_name || ""}`.trim() || "Unknown"}
                    </span>
                    <span className="friend_username">@{friend.username}</span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="no_friends">
              <span>No friends found</span>
            </div>
          )}
        </div>

        <div className="friends_list_modal_footer">
          <button className="cancel_btn" onClick={handleCancel}>
            Cancel
          </button>
          <button className="done_btn" onClick={handleDone}>
            Done ({selected.length})
          </button>
        </div>
      </div>
    </div>
  );
} 